module.exports = __webpack_public_path__ + "img/colink2.7431df97.png";